import { render, staticRenderFns } from "./OrderVisibilitySettings.vue?vue&type=template&id=2a4d6ae8&scoped=true"
import script from "./OrderVisibilitySettings.vue?vue&type=script&lang=js"
export * from "./OrderVisibilitySettings.vue?vue&type=script&lang=js"
import style0 from "./OrderVisibilitySettings.vue?vue&type=style&index=0&id=2a4d6ae8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4d6ae8",
  null
  
)

export default component.exports